import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  variant?: 'primary' | 'secondary';
  onLinkClick?: () => void;
}
const sharedClasses = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-[background-color,box-shadow,transform] duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-base';
const variantClasses: Record<'primary' | 'secondary', string> = {
  primary: 'text-white bg-accent hover:bg-accent-dark shadow-[0_8px_20px_-8px_rgba(156,82,54,0.5)] focus-visible:ring-accent-dark',
  secondary: 'text-white bg-brand hover:bg-brand-dark shadow-[0_8px_20px_-8px_rgba(94,115,85,0.45)] focus-visible:ring-brand-dark'
};
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  variant = 'primary',
  onLinkClick,
  ...props
}: ButtonProps) {
  const baseClasses = `${sharedClasses} ${variantClasses[variant]}`;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      scale: 1.04
    }} whileTap={{
      scale: 0.97
    }} transition={{
      duration: 0.16,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-42" data-mp="i2mkw1apjtlv">
        {children}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    scale: 1.04
  }} whileTap={{
    scale: 0.97
  }} transition={{
    duration: 0.16,
    ease: [0.23, 1, 0.32, 1]
  }} {...props} data-id="element-43" data-mp="3gi5sh7q1ejtk">
      {children}
    </motion.button>;
}